const apiEnum = {
  shareInfoCatAction: 'pet.user.facade.draft.cat.share', // 猫投票详情页分享
  shareMonthlyCard: 'pet.user.app.vip.share', // 分享页
  raiseFoodAction: 'pet.user.facade.raiseFood',
  getSpringActivityAction: 'pet.user.facade.getSpringActivity',
  userRegister: 'pet.user.app.user.userRegister',
  getTotalUserCoinAction: 'pet.user.app.home.getTotalUserCoin', // 查询用户爱心币
  shareActivityAction: 'pet.user.facade.ifaces.activity.shareActivity',
  uploadFile: 'pet.user.upload.uploadPicture',
  getUserPrizeListAction: 'pet.user.facade.getUserPrizeList', // 用户奖品列表
  purchaseAction: 'pet.user.app.vip.purchase',

  shareDetailAction: 'pet.user.share.shareDetail', // 通用分享详情查询接口
  getPublicShareLinkAction: 'pet.user.app.facade.getPublicShareLink', // 获取分享链接Api
  getShareLinkAction: 'pet.user.app.facade.getShareLink', // 获取分享链接

  // 外网直播间商品控制
  outUserLoginAction: 'pet.ecom.outUserLogin', // 登录

  // 猫选秀
  voteShareDetailAction: 'pet.user.facade.draft.cat.voteShareDetail',
  voteAction: 'pet.user.facade.draft.vote', // 投票

  // 品牌详情
  getSponsorDetailAction: 'pet.user.getSponsorDetail', // 赞助商详情
  getSponsorDetailNoLoginAction: 'pet.user.getSponsorDetailNoLogin', // 赞助商详情(非强登)
  
  getActivityDetailByTypeAction: 'pet.user.facade.getActivityDetailByType',
  getActivityDetailByTypeForLoginAction: 'pet.user.facade.getActivityDetailByTypeForLogin',
  requestParticipateActivityAction: 'pet.user.facade.participateActivity',
  catListAction: 'pet.user.facade.live.catList',
  
  // 视频详情
  getUserFeedShareDetailAction: 'pet.user.facade.userFeed.getUserFeedShareDetail', // 获取动态详情
  
  // 评论相关
  queryFeedCommentPageAction: 'pet.user.app.queryFeedCommentPage', // 分页查询动态评论

  // VIP MGM 相关
  vipShareAction: 'pet.user.app.vip.share', // 查询会员分享明细
  getSecondShareCardAction: 'pet.user.getSecondShareCard', // 获取二次分享小卡片信息

  // 春节活动
  getActivityInfoAction: 'pet.user.facade.activity.public.getActivityInfo', // 获取活动信息

};

export default apiEnum;

// 导出为类型化的API枚举
export const API = {
  PET_USER_APP_VIP_SHARE: apiEnum.vipShareAction,
  PET_USER_APP_USER_REGISTER: apiEnum.userRegister,
  PET_USER_GET_SECOND_SHARE_CARD: apiEnum.getSecondShareCardAction,
} as const;
